"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./style.scss");
var js_cookie_1 = __importDefault(require("js-cookie"));
var COOKIE_NAME = "cookie-age-consent";
var default_1 = (function () {
    function default_1(el) {
        var _a, _b, _c;
        this.el = el;
        this.button = (_a = el === null || el === void 0 ? void 0 : el.querySelector("button")) !== null && _a !== void 0 ? _a : null;
        if (!js_cookie_1.default.get(COOKIE_NAME)) {
            (_b = this.button) === null || _b === void 0 ? void 0 : _b.addEventListener("click", this.onOKClick.bind(this));
            (_c = this.el) === null || _c === void 0 ? void 0 : _c.classList.add("show");
        }
    }
    default_1.prototype.onOKClick = function () {
        var _a;
        if (!js_cookie_1.default.get(COOKIE_NAME)) {
            js_cookie_1.default.set(COOKIE_NAME, "true", { expires: 365 });
        }
        (_a = this.el) === null || _a === void 0 ? void 0 : _a.classList.remove("show");
    };
    default_1.prototype.setup = function () { };
    return default_1;
}());
exports.default = default_1;
